import ReactDOM from "react-dom/client";

import App from "./App";
import "./assets/styles/index.css";
import { AlertProvider } from "./contexts/AlertContext";
import { AuthProvider } from "./contexts/AuthContext";
import { AutoUpdateProvider } from "./contexts/AutoUpdateContext";
import { ConfigProvider } from "./contexts/ConfigContext";
import { LoadingProvider } from "./contexts/LoadingContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import "./dayjs";
import { currentUser } from "./services/api/AuthUser";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // Use strict mode in development.
  // <React.StrictMode>
  <ThemeProvider>
    <LoadingProvider>
      <AlertProvider>
        <AuthProvider currentUser={currentUser}>
          <ConfigProvider>
            <AutoUpdateProvider>
              <App />
            </AutoUpdateProvider>
          </ConfigProvider>
        </AuthProvider>
      </AlertProvider>
    </LoadingProvider>
  </ThemeProvider>,
  // </React.StrictMode>
);
